import React, { useEffect, useMemo, useState } from "react";
import { useTable, useGlobalFilter, useFilters, usePagination } from "react-table";
import { Row, Col, Button } from "react-bootstrap";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import "../components/table/FilteringTable/filtering.css";
import { ColumnFilter } from "../components/table/FilteringTable/ColumnFilter";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import { useDispatch } from "react-redux";
import { Fn_DeleteData, Fn_FillListData } from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import { toast } from "react-toastify";
import { isNotInUse } from "../utils/masterFilters";

export const PageList_ConcernTypeMaster = () => {
  const [gridData, setGridData] = useState([]);
  const navigate = useNavigate();
  const API_URL = API_WEB_URLS.MASTER + "/0/token/ConcernTypeMaster";
  const dispatch = useDispatch();

  const loadData = () => {
    Fn_FillListData(dispatch, setGridData, "gridData", API_URL + "/Id/0");
  };

  useEffect(() => {
    loadData();
  }, [dispatch, API_URL]);

  const btnAddOnClick   = ()   => navigate("/AddConcernType", { state: { Id: 0 } });
  const btnEditOnClick   = (Id) => navigate("/AddConcernType", { state: { Id } });

  const handleDelete = (id, name) => {
    if (!id) return;
    if (window.confirm(`Are you sure you want to delete this concern type master${name ? ` (${name})` : ""}?`)) {
      Fn_DeleteData(dispatch, setGridData, Number(id), API_URL, API_URL + "/Id/0")
        .then(() => {
          toast.success("Concern type deleted successfully");
          loadData();
        })
        .catch((error) => {
          console.error("Failed to delete concern type master:", error);
        });
    }
  };

  const COLUMNS = [
    {
      Header: "Sr No.",
      accessor: (row, index) => index + 1,
      Cell: ({ row }) => row.index + 1,
      disableFilters: true,
    },
    {
      Header: "Concern Type Name",
      Footer: "Concern Type Name",
      accessor: "Name",
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      accessor: (row) => isNotInUse(row),
      id: "Status",
      Filter: ColumnFilter,
      Cell: ({ value }) => (
        <span className={`badge ${value ? 'badge-danger' : 'badge-success'}`}>
          {value ? "Not In Use" : "Active"}
        </span>
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <div className="d-flex gap-1">
          <Button 
            variant="warning" 
            size="sm" 
            onClick={() => btnEditOnClick(row.original.Id)}
            title="Edit Concern Type"
          >
            <i className="fas fa-edit"></i>
          </Button>
          <Button 
            variant="danger" 
            size="sm" 
            onClick={() => handleDelete(row.original.Id, row.original.Name)}
            title="Delete Concern Type"
          >
            <i className="fas fa-trash"></i>
          </Button>
        </div>
      ),
      disableFilters: true,
    },
  ];

  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => gridData, [gridData]);

  const tableInstance = useTable(
    { columns, data, initialState: { pageIndex: 0 } },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  return (
    <Container fluid className="page-content">
      <Row className="mb-3 align-items-center">
        <Col md="6">
          <h4 className="page-title mb-0" style={{ fontFamily: "Poppins" }}>
            <i className="fas fa-building me-2" style={{ color: "#7c69ef" }}></i>
            Concern Type Master
          </h4>
        </Col>
        <Col md="auto" className="ms-auto d-flex gap-2">
          <Button 
            type="button" 
            onClick={btnAddOnClick} 
            variant="success" 
            size="sm"
            className="d-flex align-items-center"
          >
            <i className="fas fa-plus me-1"></i>Add New
          </Button>
        </Col>
      </Row>
      
      <Row className="mb-3">
        <Col md="8">
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
        </Col>
        <Col md="4" className="text-end">
          <span className="text-muted">
            Total Records: <strong>{data.length}</strong>
          </span>
        </Col>
      </Row>

      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">Concern Types List</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table {...getTableProps()} className="table table-striped table-hover dataTable display">
              <thead className="table-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()} style={{ fontSize: "14px", fontWeight: "600" }}>
                        {column.render("Header")}
                        {column.canFilter ? (
                          <div className="mt-1">{column.render("Filter")}</div>
                        ) : null}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.length > 0 ? (
                  page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()} style={{ fontSize: "13px" }}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                        ))}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={columns.length} className="text-center py-4">
                      <div className="d-flex flex-column align-items-center">
                        <i className="fas fa-inbox fa-3x text-muted mb-2"></i>
                        <span className="text-muted">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            
            {page.length > 0 && (
              <>
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    <span className="text-muted">
                      Showing <strong>{page.length}</strong> of <strong>{data.length}</strong> entries
                    </span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="text-muted">Page:</span>
                    <strong>{pageIndex + 1} of {pageOptions.length}</strong>
                    <span className="ms-3">Go to page:</span>
                    <input
                      type="number"
                      className="form-control form-control-sm d-inline-block"
                      style={{ width: "70px" }}
                      min="1"
                      max={pageOptions.length}
                      defaultValue={pageIndex + 1}
                      onChange={(e) => {
                        const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                        if (pageNumber >= 0 && pageNumber < pageOptions.length) {
                          gotoPage(pageNumber);
                        }
                      }}
                    />
                  </div>
                  <div>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => previousPage()}
                      disabled={!canPreviousPage}
                      className="me-2"
                    >
                      Previous
                    </Button>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => nextPage()}
                      disabled={!canNextPage}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PageList_ConcernTypeMaster;
